import React, { useMemo } from 'react';
import { serializeLogs, clearLogs } from '../lib/logBus';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiCopy, FiDownload, FiTrash2 } = FiIcons;

export default function ErrorPopup({ error, onClose }) {
  const text = useMemo(() => {
    if (!error) return '';
    const core = `${error.message || String(error)}\n${error.stack || ''}`;
    return core.trim();
  }, [error]);

  const copyThis = async () => {
    try {
      await navigator.clipboard.writeText(text);
      alert('Error copied to clipboard.');
    } catch {
      alert('Failed to copy. Please select and copy the text manually.');
    }
  };

  const copyLogs = async () => {
    try {
      await navigator.clipboard.writeText(serializeLogs('text'));
      alert('All logs copied.');
    } catch {
      alert('Failed to copy. Please use the download buttons.');
    }
  };

  const downloadLogs = (fmt = 'txt') => {
    const t = fmt === 'json' ? serializeLogs('json') : serializeLogs('text');
    const blob = new Blob([t], { type: fmt === 'json' ? 'application/json' : 'text/plain' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `promptly-logs.${fmt}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-2xl max-h-[90vh] flex flex-col rounded-2xl bg-white shadow-xl">
        <div className="flex-shrink-0 flex items-center justify-between gap-3 p-4 border-b">
          <h2 className="text-lg font-semibold text-slate-800">An Error Occurred</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 transition-colors">
            <SafeIcon icon={FiX} className="w-5 h-5 text-slate-600" />
          </button>
        </div>

        <div className="flex-grow p-4 overflow-y-auto">
          <label className="text-sm font-medium text-slate-700">Error Details</label>
          <textarea
            readOnly
            value={text}
            className="mt-1 w-full h-48 border border-slate-300 rounded-lg p-3 font-mono text-sm bg-slate-50 focus:outline-none focus:ring-2 focus:ring-red-500"
            style={{ userSelect: 'text' }}
          />
        </div>

        <div className="flex-shrink-0 p-4 border-t bg-slate-50 rounded-b-2xl">
          <div className="flex flex-wrap gap-2">
            <button onClick={copyThis} className="flex items-center gap-2 rounded-lg px-3 py-2 border bg-white hover:bg-slate-100 text-sm font-medium text-slate-700">
              <SafeIcon icon={FiCopy} /> Copy Error
            </button>
            <button onClick={copyLogs} className="flex items-center gap-2 rounded-lg px-3 py-2 border bg-white hover:bg-slate-100 text-sm font-medium text-slate-700">
             <SafeIcon icon={FiCopy} /> Copy Logs
            </button>
            <button onClick={() => downloadLogs('txt')} className="flex items-center gap-2 rounded-lg px-3 py-2 border bg-white hover:bg-slate-100 text-sm font-medium text-slate-700">
              <SafeIcon icon={FiDownload} /> Download .txt
            </button>
            <button onClick={() => downloadLogs('json')} className="flex items-center gap-2 rounded-lg px-3 py-2 border bg-white hover:bg-slate-100 text-sm font-medium text-slate-700">
              <SafeIcon icon={FiDownload} /> Download .json
            </button>
            <button onClick={() => { clearLogs(); alert('Cleared local log buffer.'); }} className="flex items-center gap-2 rounded-lg px-3 py-2 border bg-white hover:bg-red-50 text-sm font-medium text-red-600">
              <SafeIcon icon={FiTrash2} /> Clear Logs
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}